<svg
  class="loading-spinner hmf-display-block hmf-h-100 hmf-w-100"
  viewBox="0 0 40 40"
  aria-hidden="true">
  <circle
    class="loading-spinner-ring"
    cx="20"
    cy="20"
    r="16"
    fill="none"
    stroke-width="4" />
</svg>
